import { isEmpty, findIndex, filter } from 'lodash';
import { CHARM, STICKER } from './productDetailsConstants';
import { getNotifyMeClearanceStatuses } from '../utils/globalDataHelpers';

const { classificationGroupId } = window.inlineGlobalConfig;

export const findColorSwatches = classificationGroups => {
  const productGroup = classificationGroups.find(
    classificationGroup => classificationGroup.id === classificationGroupId
  );
  return productGroup && productGroup.classificationGroup ? productGroup.classificationGroup : [];
};

export const getActualSwatch = (colorSwatches, actualColorId) =>
  !isEmpty(colorSwatches) || actualColorId ? [...colorSwatches].find(swatch => actualColorId === swatch.id) : {};

export const buildMediaURL = colorSwatches =>
  colorSwatches.map(swatch => ({
    ...swatch,
    mediaURL: swatch.swatchUrl,
  }));

export const getSizeData = data => {
  let sizeVariationIndex = -1;

  if (data.variationFields) {
    sizeVariationIndex = findIndex(data.variationFields, field => field.name === 'size');
  }

  return sizeVariationIndex >= 0
    ? data.skus.map(size => ({
        sku: size.id,
        name: size.variationValues[sizeVariationIndex].name,
        size: size.variationValues[sizeVariationIndex].value,
        dataLayerName: size.variationValues[sizeVariationIndex].dataLayerName,
        count: size.stock,
        hybrisSizeCode: size.variationValues[sizeVariationIndex].id,
      }))
    : [];
};

export const getClearanceStatus = data => {
  const entry = data?.classificationData?.entry?.find(element => element.key === 'clearanceStatus');
  return entry ? entry.value : '';
};

export const isFullPrice = data => {
  if (!data) return false;
  const clearanceStatus = getClearanceStatus(data);
  return clearanceStatus === 'Full Price' || clearanceStatus === '';
};

export const isNotifyMeAllowed = data => {
  if (!data) return false;
  const clearanceStatus = getClearanceStatus(data);
  return clearanceStatus === '' || getNotifyMeClearanceStatuses().includes(clearanceStatus);
};

export const isColourVariantFullPrice = data => {
  if (!data) return false;
  const { clearanceStatus } = data;
  return clearanceStatus === 'N';
};

export const getStyleId = loadedProduct =>
  loadedProduct.classificationData.entry.find(e => e.key === 'styleCode').value;

export const getColorId = loadedProduct =>
  loadedProduct.classificationData.entry.find(e => e.key === 'colorCode').value;

export const isMultiVariantProduct = productType => productType !== CHARM && productType !== STICKER;

export const getClassificationProperty = (classificationData, propertyName) => {
  return (
    classificationData &&
    !isEmpty(classificationData.entry) &&
    filter(classificationData.entry, dataObject => dataObject.key === propertyName)[0].value
  );
};

export const getClassificationPropertyDetailed = (classifications, propertyName) => {
  return classifications[0]?.features?.find(f => f.featureCode === propertyName)?.featureValues[0];
};

const SIZE_SELECTOR_SCROLL_OFFSET = 20;

export const scrollToSizeSelector = (offset = 0) => {
  const sizeSelector = document.querySelector('.size-selector');
  if (!sizeSelector) return;
  const top = sizeSelector.getBoundingClientRect().top + window.pageYOffset - offset - SIZE_SELECTOR_SCROLL_OFFSET;
  window.scrollTo({ top, behavior: 'smooth' });
};
